import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { baseColors } from "theme";

export const styles = (theme: Theme) =>
	({
		pageTitle: {
			fontSize: 42
		},
		iconBorder:{
			border: "1px solid grey",
			borderRadius: "50%",
			padding: "15px !important",
			height: 95,
			width: 95
		},
		icon: {
			marginTop: 7.5,
			marginLeft: 7.5,
			height: 47,
			width: 47,
		},
		topicTitle: {
			fontWeight: 800
		},
		topicLink:{
			color: "#2A2A2A",
			fontWeight: 600
		},
		topicButton: {
			border: "3px solid #2A2A2A",
			width: 80
		},
		sfHeaderTitle: {
			fontWeight: 700,
			fontSize: 24,
			color: theme.palette.text.primary,
		},
		sfHeaderSubtitle: {
			fontSize: 14,
			fontWeight: 600,
			color: theme.palette.text.secondary,
			marginTop: 12,
			marginBottom: 12
		},
		sfCardContainer: {
			border: `1px solid ${theme.palette.custom.divider}`,
			borderRadius: 8,
			backgroundColor: theme.palette.common.white,
			overflow: "hidden",
		},
		sfCardInner: {
			padding: 24,
			height: "100%",
			boxSizing: "border-box",
		},
		sfIconCircle: {
			width: 80,
			height: 80,
			borderRadius: "50%",
			backgroundColor: theme.palette.secondary.main,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		sfIcon: {
			color: baseColors.white,
			fontSize: 40,
		},
		sfCardTitle: {
			fontWeight: 700,
			fontSize: 16,
		},
		sfCardDescription: {
			color: theme.palette.text.secondary,
			textAlign: "center" as const,
		},
		sfButtonWrapper: {
			width: "100%",
			marginTop: 16,
		},
		sfButton: {
			width: "100%",
			backgroundColor: theme.palette.primary.main,
			color: baseColors.white,
			textTransform: "none" as const,
			fontWeight: 600,
			"&:hover": {
				backgroundColor: baseColors.teal500,
			},
		},
		sfCardBorderLeft: {
			borderLeft: `1px solid ${theme.palette.custom.divider}`,
		},
	} satisfies Record<string, CSSObject>);
